module.exports = __webpack_public_path__ + "static/media/fold-dieline.a25e2db5.png";